import { render, staticRenderFns } from "./ToastMessage.vue?vue&type=template&id=bb053dd6"
import script from "./ToastMessage.vue?vue&type=script&lang=js"
export * from "./ToastMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports